<template>

  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
          <b-row>
            <b-col cols="12">
              Selected Profile: {{this.profile.name}} - {{this.profile.houseno}}
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col>
              <b-table selectable
                       select-mode="multi"
                       hover
                       :items="readingPayments"
                       :fields="fields"
                       id="dataTable"
                       ref="dataTable"
                       responsive="sm"
                       @row-selected="onRowSelected">
                <template #cell(readingdate)="data">
                    <b>{{ data.value}}</b>
                  </template>
                <template #cell(balance)="data">
                    <b>{{ data.value}}</b>
                  </template>
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Total Amount Selected" label-for="selectedAmount">
                <b-form-input id="selectedAmount"
                              type="text"
                              v-model.lazy.trim="$v.form.selectedAmount.$model"
                              readonly
                              placeholder="Selected Amount"
                              autofocus>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Amount Received" label-for="receivedAmount">
                <b-form-input id="receivedAmount"
                              name="receivedAmount"
                              type="text"
                              :readonly="$v.form.selectedAmount.$model <= 0"
                              :state="validateState('receivedAmount')"
                              aria-describedby="liveFeedbackreceivedamount"
                              v-model.lazy.trim="$v.form.receivedAmount.$model"
                              placeholder="Bhaint Amount Recieved" />
                <b-form-invalid-feedback id="liveFeedbackreceivedamount">
                  This is a required field and can only contains numbers.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Bhaint Method" label-for="paymentMethod">
                <v-select ref="paymentMethod"
                          id="paymentMethod"
                          placeholder="Bhaint Received Type"
                          name="paymentMethod"
                          :class="{ danger: $v.form.paymentMethod.$error }"
                          @search:blur="$v.form.paymentMethod.$touch()"
                          :state="validateState('paymentMethod')"
                          :options="paymentMethodList"
                          aria-describedby="liveFeedbackpaymentmethod"
                          v-model="$v.form.paymentMethod.$model"
                          :reduce="payment => payment.id"
                          label="paymentName"></v-select>
                <span v-show="$v.form.paymentMethod.$error" class="danger-span">
                   This is required field.
                 </span>
                <b-form-invalid-feedback id="liveFeedbackpaymentmethod">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Description" label-for="description">
                <b-form-input id="description"
                              type="text"
                              aria-describedby="liveFeedbackdescription"
                              v-model.lazy.trim="form.description"
                              placeholder="Payment Description" />
                <b-form-invalid-feedback id="liveFeedbackdescription">
                    This is required when Bhaint Method is other than Cash.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
                Submit
              </b-button>
              <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
              <br />
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

  import Vue from 'vue'
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import { mapState, mapActions } from 'vuex'
  import { required, decimal, helpers, minValue, requiredIf } from 'vuelidate/lib/validators'
  const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
  const alpha_numeric = helpers.regex('alpha_space', /^[a-zA-Z0-9\s]*$/)
  const formShape = {
    selectedAmount: null,
    receivedAmount: null,
    paymentMethod: null,
    description: null,
    readings: null,
    readingPayments: null,
    selectedReadings: []
  }
  export default {
    name: 'PayDues',
    props: {
      profile: Object
    },
    data() {
      return {
        form: Object.assign({}, formShape),
        submitted: false,
        fields: ['selected', { key: 'readingdate', label: 'Reading Date' }, { key: 'balance', label: 'Balance' }],
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        reamingTotal: 0
      }
    },
    computed: {
      isValid() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      isDirty() {
        return this.$v.form.$anyDirty
      },
      paymentMethodList() {
        return map(this.$store.state.electrical.paymentMethods, payment => {
          return {
            paymentName: payment.type,
            id: payment.id,
            required: payment.required
          }
        })
      },
      readingPayments() {
        try {
          if (!(this.form.readings === null)) {
            const readingsByMonths = this.form.readings.reduce((acc, value) => {
              var date = new Date(value.readingdate)

              if (isNaN(date)) {
                throw 'Invalid Reading date for id: ' + value.id
              }
              const monthYear = this.months[date.getMonth()] + '/' + date.getFullYear()
              if (!acc[monthYear]) {
                acc[monthYear] = []
              }

              acc[monthYear].push(value)

              return acc
            }, {})

            return map(readingsByMonths, (value, key) => {
              return {
                readingdate: key,
                balance: value.reduce((acc, reading) => {
                  return acc + reading.balance
                }, 0),
                readings: value
              }
            })
          }
        } catch (err) {
          this.showErrorMsg({
            message: err
          })
          this.$emit('cancel')
        }
      }
    },
    validations: {
      form: {
        selectedAmount: {
          required,
          decimal,

        },
        receivedAmount: {
          required: requiredIf(function(nestedModel) {
            return this.form.selectedAmount > 0
          }),
          decimal
        },
        paymentMethod: {
          required
        },
        description: {
          required: requiredIf(function(nestedModel) {
            return this.form.paymentMethod.required
          }),
          alpha_numeric
        }
      }
    },
    methods: {
      onRowSelected(items) {
        this.form.selectedAmount = items.reduce((acc, reading) => {
          return acc + reading.balance
        }, 0)
      },
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name]
        return $dirty ? !$error : null
      },
      getAmountToPay(charge) {
        let amountToReturn;
        if (this.reamingTotal >= charge) {
          this.reamingTotal = this.reamingTotal - charge
          amountToReturn = charge
        } else {
          amountToReturn = this.reamingTotal
          this.reamingTotal = 0
        }

        return amountToReturn
      },
      createUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })
      },
      onSubmit() {
        let valid = this.validateAndSetPayments() ;

        if (this.validate() && valid) {

          this.$nextTick(() => {
            this.submitted = true
            let selectedAmount = parseFloat(this.form.selectedAmount);
            let hasNegative = this.checkIfNegativeSelected()
            var d = new Date()
            if (selectedAmount > 0 && hasNegative == false) {
              let selectedRows = this.$refs.dataTable.selectedRows
              if (selectedRows != null && selectedRows.length > 0) {
                selectedRows.sort(function(a, b) {
                  return a - b
                })

                let newPayment = {
                  amount: null,
                  id: this.createUUID(),
                  paymentDate: d.toISOString(),
                  paymentType: null,
                  paymentDescription: null,
                  readingPayments: [],
                  paymentDescRequired: this.form.paymentMethod.required
                }
                let sprTemplate = {
                  paymentId: null,
                  readingId: null,
                  amount: null
                }

                newPayment['amount'] = this.reamingTotal

                for (var key = 0; key < selectedRows.length; key++) {
                  if (this.reamingTotal > 0) {
                    let selectedReadings = this.$refs.dataTable.items[key].readings
                    selectedReadings.forEach(function(item, index) {
                      let spr = JSON.parse(JSON.stringify(sprTemplate))
                      spr['paymentId'] = newPayment['id']
                      spr['readingId'] = item.id
                      spr['amount'] = this.getAmountToPay(item.balance)
                      newPayment['readingPayments'].push(spr)
                    }, this)
                  } else {
                    break
                  }
                }
                if (newPayment != null && newPayment['readingPayments'].length > 0) {
                  newPayment['paymentType'] = this.form.paymentMethod.id
                  newPayment['paymentDescription'] = this.form.paymentMethod.paymentName
                  newPayment['amount'] = newPayment['readingPayments'].reduce((acc, reading) => {
                    let amount = reading.amount;
                    if(amount < 0){
                      amount = (-1) * amount;
                    }
                    return acc + amount;
                  }, 0)
                  this.applyPayment(newPayment)
                } else {
                  this.showErrorMsg({ message: 'Nothing to apply. Closing window.' })
                  this.$emit('cancel')
                }
              }
            } else {

              let selectedRows = this.$refs.dataTable.selectedRows
              let negativeAmount = 0
              let negativeAmountList = []
              let positiveAmountList = []
              let positivAmount = 0
              if (selectedRows != null && selectedRows.length > 0) {
                for (var key = 0; key < selectedRows.length; key++) {
                  let selectedReadings = this.$refs.dataTable.items[key].readings

                    selectedReadings.filter(function(r) {
                      return r.balance < 0
                    }).forEach(reading =>   negativeAmountList.push(reading));


                    selectedReadings.filter(function(r) {
                       return r.balance >= 0
                    }).forEach(reading=> positiveAmountList.push(reading));

                }

                positivAmount = positiveAmountList.reduce((acc, reading) => {
                  return acc + reading.balance
                }, 0)
                negativeAmount = negativeAmountList.reduce((acc, reading) => {
                  return acc + ((-1) * reading.balance)
                }, 0)

                if (negativeAmount > positivAmount) {
                  let newPayment = {
                    amount: null,
                    id: this.createUUID(),
                    paymentDate: d.toISOString(),
                    paymentType: null,
                    paymentDescription: null,
                    readingPayments: [],
                    paymentDescRequired: this.form.paymentMethod.required
                  }
                  let sprTemplate = {
                    paymentId: null,
                    readingId: null,
                    amount: null
                  }
                  newPayment['amount'] = positivAmount
                  positiveAmountList.forEach(function(item, index) {
                    let spr = JSON.parse(JSON.stringify(sprTemplate))
                    spr['paymentId'] = newPayment['id']
                    spr['readingId'] = item.id
                    spr['amount'] = item.balance
                    newPayment['readingPayments'].push(spr)
                  })
                  this.reamingTotal = positivAmount
                  negativeAmountList.forEach(function(item, index) {
                    if (this.reamingTotal > 0) {
                      let balance = -1 * item.balance
                      balance = this.getAmountToPay(balance)
                      let spr = JSON.parse(JSON.stringify(sprTemplate))
                      spr['paymentId'] = newPayment['id']
                      spr['readingId'] = item.id
                      spr['amount'] = -1 * balance
                      newPayment['readingPayments'].push(spr)
                    }
                  }, this)
                  if (newPayment != null && newPayment['readingPayments'].length > 0) {
                    newPayment['paymentType'] = this.form.paymentMethod.id
                    newPayment['paymentDescription'] = this.form.paymentMethod.paymentName
                    newPayment['amount'] = newPayment['readingPayments'].reduce((acc, reading) => {
                      let amount = reading.amount;
                      if(amount < 0){
                        amount = (-1) * amount;
                      }
                      return acc + amount;
                    }, 0)
                    this.applyPayment(newPayment)
                  } else {
                    this.showErrorMsg({ message: 'Nothing to apply. Closing window.' })
                    this.$emit('cancel')
                  }
                } else if (negativeAmount < positivAmount) {
                  let newPayment = {
                    amount: null,
                    id: this.createUUID(),
                    paymentDate: d.toISOString(),
                    paymentType: null,
                    paymentDescription: null,
                    readingPayments: [],
                    paymentDescRequired: this.form.paymentMethod.required
                  }
                  let sprTemplate = {
                    paymentId: null,
                    readingId: null,
                    amount: null
                  }
                  newPayment['amount'] = positivAmount

                  let amountRecieved = parseFloat(this.form.receivedAmount);

                  if (isNaN(amountRecieved)) {
                    this.reamingTotal = negativeAmount
                  } else {
                    this.reamingTotal = negativeAmount + amountRecieved
                  }

                  positiveAmountList.forEach(function(item, index) {
                    if (this.reamingTotal > 0) {
                      let spr = JSON.parse(JSON.stringify(sprTemplate))
                      spr['paymentId'] = newPayment['id']
                      spr['readingId'] = item.id
                      spr['amount'] = this.getAmountToPay(item.balance)
                      newPayment['readingPayments'].push(spr);

                    }
                  }, this);

                  negativeAmountList.forEach(function(item, index) {
                    let spr = JSON.parse(JSON.stringify(sprTemplate))
                    spr['paymentId'] = newPayment['id']
                    spr['readingId'] = item.id
                    spr['amount'] = item.balance
                    newPayment['readingPayments'].push(spr)

                  });

                  if (newPayment != null && newPayment['readingPayments'].length > 0) {
                    newPayment['paymentType'] = this.form.paymentMethod.id
                    newPayment['paymentDescription'] = this.form.paymentMethod.paymentName
                    newPayment['amount'] = newPayment['readingPayments'].reduce((acc, reading) => {
                      let amount = reading.amount;
                      if(amount < 0){
                        amount = (-1) * amount;
                      }
                      return acc + amount;
                    }, 0)
                    this.applyPayment(newPayment)
                  } else {
                    this.showErrorMsg({ message: 'Nothing to apply. Closing window.' })
                    this.$emit('cancel')
                  }
                } else if (negativeAmount == positivAmount) {
                  let newPayment = {
                    amount: null,
                    id: this.createUUID(),
                    paymentDate: d.toISOString(),
                    paymentType: null,
                    paymentDescription: null,
                    readingPayments: [],
                    paymentDescRequired: this.form.paymentMethod.required
                  }
                  let sprTemplate = {
                    paymentId: null,
                    readingId: null,
                    amount: null
                  }
                  newPayment['amount'] = positivAmount
                  positiveAmountList.forEach(function(item, index) {
                    let spr = JSON.parse(JSON.stringify(sprTemplate))
                    spr['paymentId'] = newPayment['id']
                    spr['readingId'] = item.id
                    spr['amount'] = item.balance
                    newPayment['readingPayments'].push(spr)
                  })

                  negativeAmountList.forEach(function(item, index) {
                    let spr = JSON.parse(JSON.stringify(sprTemplate))
                    spr['paymentId'] = newPayment['id']
                    spr['readingId'] = item.id
                    spr['amount'] = item.balance
                    newPayment['readingPayments'].push(spr)
                  })
                  if (newPayment != null && newPayment['readingPayments'].length > 0) {
                    newPayment['paymentType'] = this.form.paymentMethod.id
                    newPayment['paymentDescription'] = this.form.paymentMethod.paymentName
                    newPayment['amount'] = newPayment['readingPayments'].reduce((acc, reading) => {
                      let amount = reading.amount;
                      if(amount < 0){
                        amount = (-1) * amount;
                      }
                      return acc + amount;
                    }, 0)
                    this.applyPayment(newPayment)
                  } else {
                    this.showErrorMsg({ message: 'Nothing to apply. Closing window.' })
                    this.$emit('cancel')
                  }
                } else {
                  this.showErrorMsg({ message: 'Nothing to apply. Closing window.' })
                  this.$emit('cancel')
                }
              } else {
                this.showErrorMsg({ message: 'Please select the amounts before clicking save button ' })
                return
              }
            }
          })
        }
      },
      applyPayment(params) {

        this.$store
          .dispatch('electrical/applyPayment', params)
          .then(response => {
            if (response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              })
            } else {
              this.showSuccessMsg({
                message: 'Payment applied successfully.'
              })
              this.$emit('success')
            }
          })
          .catch(error => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else if (error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
            }
          })
      },
      onCancel() {
        this.$emit('cancel')
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
      validate() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      validateAndSetPayments() {

        this.reamingTotal = parseFloat(this.form.receivedAmount);
        if (isNaN(this.reamingTotal)) {
          if (this.checkHasNegativeAndPositive() == true) {
            return true
          } else if (this.checkIfNegativeSelected() == true) {
            this.showErrorMsg({ message: 'Please select positive amount along with negative before saving a record.' })
            return false
          }
          this.showErrorMsg({ message: 'Please enter Amount Received in number only before saving a record.' })
          return false
        } else {

          let selectedAmount = parseFloat(this.form.selectedAmount);

          if (isNaN(selectedAmount)) {
            this.showErrorMsg({ message: 'Please enter Total Amount Selected in number only before saving a record.' })
            return false
          } else {

            if (this.reamingTotal > selectedAmount) {
              if (this.reamingTotal == 0 && this.checkHasNegativeAndPositive() == true) {
                return true
              }
              this.showErrorMsg({ message: 'Receiving amount should be less than or equal to selected amount.' })
              return false
            }
            return true;
          }
        }
      },
      checkHasNegativeAndPositive() {
        let hasNeg = this.checkIfNegativeSelected()
        if (hasNeg == true) {
          hasNeg = false
          let selectedRows = this.$refs.dataTable.selectedRows
          if (selectedRows != null && selectedRows.length > 0) {
              let exists = false
            for (var key = 0; key < selectedRows.length && exists == false; key++) {
              exists = this.$refs.dataTable.items[key].readings.some(row => {
                if (row.balance > 0) {
                  return true
                }
              })
              if (exists == true) {
                hasNeg = true
              }
            }
          }
        }
        return hasNeg
      },
      checkIfNegativeSelected() {
        let returnValue = false
        let selectedRows = this.$refs.dataTable.selectedRows
        if (selectedRows != null && selectedRows.length > 0) {
          let exists = false
          for (var key = 0; key < selectedRows.length && exists == false; key++) {
            exists = this.$refs.dataTable.items[key].readings.some(row => {
              if (row.balance < 0) {
                return true
              }
            })
            if (exists == true) {
              returnValue = true
            }
          }
        }
        return returnValue
      }
    },
    beforeMount() {},
    created() {
      if (this.$store.state.electrical.paymentMethods.length == 0) {
        this.$store.dispatch('electrical/getPaymentMethods')
      }
      let param = { id: this.profile.id }
      axios
        .post('/electrical/reading/getReadingsBalance', param, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          this.form.readings = response.data.data.data

        })
        .catch(error => {
          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else if (error.response.status == 422) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
          }
        })
    }
  }

</script>

<style media="screen">

  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;
  }

  .borderCard {
    border: 1px solid #e3e8ec;
  }

</style>
